<template>
    <y-container>
        <header class="r-header">
            <div class="r-header__container">
                <div class="r-header__logo">
                    <router-link :to="{ name: 'home' }">
                        <img
                            v-if="$settings('site_logos.header')"
                            :src="$settings('site_logos.header.link')"
                            :alt="$settings('site_title.site_title')"
                            class="r-header__logo__image"
                        >
                    </router-link>
                </div>
                <div
                    class="r-header__menu"
                    :class="{mobileMenu}"
                >
                    <div class="r-header__menu--mobile__padd">
                        <y-row class="r-header__menu--mobile__padd__auth-schedule">
                            <y-col>
                                <y-button
                                    :content="$t('general.header.schedule')"
                                    tag="router-link"
                                    :to="{name: 'schedule-demo'}"
                                    href="/demo"
                                    size="small"
                                    color="primary"
                                    :no-padding="true"
                                    class="r-header__items__button-schedule--mobile pt-1"
                                />
                            </y-col>
                            <y-col>
                                <div class="r-header__auth">
                                    <div v-if="isLogin">
                                        <y-auth
                                            :avatar-img="avatarImg"
                                            :user="user"
                                            image-width="32px"
                                            image-height="32px"
                                        />
                                    </div>
                                    <a
                                        v-else
                                        class="r-header__auth__link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://cloud.quarkino.com/login"
                                    >
                                        {{ $t('general.header.log_in') }}
                                    </a>
                                </div>
                            </y-col>
                        </y-row>

                        <y-select
                            class="r-header__flag-select r-header__flag-select--mobile"
                            no-label
                            :options="availableLocales"
                            :init="initLocal"
                            @select="changeLocale($event)"
                        />
                        <y-menu
                            :items="getMenu('header-$')"
                            class="r-header__menu--main menu-position--right"
                            arrow="2"
                        />
                    </div>
                </div>
                <div class="r-header__items">
                    <div class="r-header__menu__hamburger">
                        <y-icon
                            :icon="mobileMenu ? 'times' :'bars'"
                            size="normal"
                            color="white"
                            @click.native="toggleMenu"
                        />
                    </div>
                    <div class="r-header__auth r-header__auth-desktop">
                        <div v-if="isLogin">
                            <y-auth
                                :avatar-img="avatarImg"
                                :user="user"
                                image-width="32px"
                                image-height="32px"
                            />
                        </div>
                        <a
                            v-else
                            class="r-header__auth__link"
                            :href="`${parentOrigin}login`"
                        >
                            {{ $t('general.header.log_in') }}
                        </a>
                    </div>
                    <y-button
                        :content="$t('general.header.sign_up')"
                        size="small"
                        tag="a"
                        :href="`${parentOrigin}signup`"
                        color="primary"
                        :no-padding="true"
                        class="r-header__items__button-schedule"
                    />
                    <!--                    <y-select -->
                    <!--                        class="r-header__flag-select r-header__flag-select&#45;&#45;desktop" -->
                    <!--                        no-label -->
                    <!--                        :options="availableLocales" -->
                    <!--                        :init="initLocal" -->
                    <!--                        @select="changeLocale($event)" -->
                    <!--                    /> -->
                </div>
            </div>
        </header>
    </y-container>
</template>

<script>
    import {
        YIcon,
        // YSelect,
    } from '@groot-components/all';
    // import { options as localeOptions } from '@groot-nodes/locales/src/configs';
    import YAuth from './blocks/Auth/Index.vue';
    import YMenu from './blocks/Menu/Menu.vue';

    export default {

        name: 'Header',

        components: {
            // YSelect,
            YMenu,
            YIcon,
            YAuth,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                isMenuOpen  : false,
                mobileMenu  : false,
                isLogin     : false,
                user        : null,
                avatarImg   : null,
                parentOrigin: process.env.VUE_APP_PARENT_ORIGIN,
            };
        },

        computed: {
            /**
             * Return mode of header class
             *
             * @returns {Array}
             */
            mode() {
                const classes = ['dark'];
                if (this.$route.name.startsWith('news')) {
                    classes.push('hacker-news');
                }
                return classes;
            },
            //
            // /**
            //  * Return available options locales
            //  *
            //  * @returns {Array}
            //  */
            // availableLocales() {
            //     return this.$i18n.availableLocales.map((loc) => ({
            //         // eslint-disable-next-line global-require, import/no-dynamic-require
            //         img  : require(`../../../assets/images/flags/simple/${loc}.svg`),
            //         text : localeOptions.find((item) => item.code === loc).title,
            //         label: loc.toUpperCase(),
            //         value: loc,
            //     }));
            // },

            // /**
            //  * Return init select values
            //  *
            //  * @returns {string}
            //  */
            // initLocal() {
            //     return this.availableLocales.find((locale) => locale.value === this.$route.params?.locale)?.value || this.availableLocales[0].value;
            // },
        },

        watch: {
            $route: {
                /**
                 * Close mobile menu & set logo
                 */
                handler() {
                    this.mobileMenu = false;
                    if (this.$route.query.logout) {
                        this.$store.dispatch('auth/logout');
                        this.isLogin = false;
                    }
                },

                deep     : true,
                immediate: true,
            },
        },

        /**
         * @inheritDoc
         */
        created() {
            if (this.$store.getters['auth/isLoggedIn']) {
                this.isLogin = true;
                this.fetch();
            }
        },

        methods: {
            // /**
            //  * Change route locale
            //  *
            //  * @param {object} locale - Locale object
            //  */
            // changeLocale(locale) {
            //     if (window.self !== window.top) {
            //         window.parent.postMessage(
            //             JSON.stringify({ event: 'route-change', payload: `/${locale.value}` }),
            //             process.env.VUE_APP_PARENT_ORIGIN,
            //         );
            //     }
            //     this.$router.replace({ name: 'home', params: { locale: locale.value } });
            // },

            /**
             * Open mobile menu
             */
            toggleMenu() {
                this.mobileMenu = !this.mobileMenu;
            },

            /**
             * fetch user info
             *
             * @returns {Promise}
             */
            fetch() {
                return this.$services.Person.userEditProfileFetch()
                    .then((response) => {
                        const avatar = response.data.metadata;
                        this.user = response.data.results;
                        this.avatarImg = avatar.avatar.resource['0'];
                    })
                    .catch((error) => {
                        this.handleError(error);
                    });
            },

        },
    };
</script>

<style lang="scss" src="./index.scss" />
